'use client'

import { GraftabilityIssueList } from '@/core/components/GraftabilityIssueList'

import { WIZARD_COPY } from '../../const'
import type { AnalyzerCommentsSectionProps } from '../../types'

import styles from './AnalyzerCommentsSection.module.scss'

export function AnalyzerCommentsSection({ issues }: AnalyzerCommentsSectionProps) {
  return (
    <section className={styles.section} aria-labelledby="graft-filter-wizard-issues">
      <h3 id="graft-filter-wizard-issues" className={styles.sectionTitle}>
        {WIZARD_COPY.sections.analyzerComments}
      </h3>
      <GraftabilityIssueList issues={issues} limit={8} />
    </section>
  )
}
